import { useState, useCallback, SyntheticEvent } from 'react';

const WIDE_LOGO_WIDTH = 220;
const TALL_LOGO_WIDTH = 150;

interface AdaptiveLogoProps {
  src: string;
  alt?: string;
}

function AdaptiveLogo({ src, alt = 'image' }: AdaptiveLogoProps) {
  const [computedWidth, setComputedWidth] = useState<number | null>(null);

  const handleLoad = useCallback((e: SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;
    if (naturalHeight === 0) {
      setComputedWidth(TALL_LOGO_WIDTH);
      return;
    }
    const isWide = naturalWidth / naturalHeight >= 2;
    setComputedWidth(isWide ? WIDE_LOGO_WIDTH : TALL_LOGO_WIDTH);
  }, []);

  return (
    <div
      data-testid="logo-wrapper"
      style={{
        width: computedWidth ? `${computedWidth}px` : 'auto'
      }}
    >
      <img src={src} alt={alt} onLoad={handleLoad} className="block w-full h-auto object-contain" />
    </div>
  );
}

export default AdaptiveLogo;
